import http from '@core/fetch'

export default {
  getListTabCount: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/listTabCount', {
      body
    }),

  getMaterialList: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/index', { body }),

  getMaterialDetail: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/detail', { body }),

  getContentsByType: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/contents', {
      body,
      expect: []
    }),
  getTypesByPosition: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/types', {
      body,
      expect: []
    }),
  addMaterial: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantMaterials/add', { body }),
  updateMaterial: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantMaterials/update', {
      body,
      ignore: [undefined]
    }),
  deleteMaterial: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantMaterials/delete', {
      body
    }),
  getDataDetail: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/dataDetail', {
      body
    }),
  getAnalysisData: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/StatChart', {
      body,
      expect: []
    }),
  getMaterials: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/detailList', {
      body
    }),
  getQAData: body =>
    http('/p/wedding/index.php/admin/APIMerchantMaterials/qaAnswer', {
      body
    })
}
